import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Button, Modal} from 'react-bootstrap';
import {DatePicker} from 'antd';
import moment from 'moment';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';
import * as actions from '../_redux/userDetailsActions';
import {useParams} from 'react-router-dom';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

const PopupUploadForm101 = ({
                              isOpen,
                              onHide
                            }) => {
  const dispatch = useDispatch();
  const userMongoId = useParams().userId;
  const user = useSelector(
    (state) => state.userDetails.user,
    shallowEqual
  );
  const uploadRef = useRef();
  const [date, setDate] = useState(null);
  const [file, setFile] = useState(null);

  const uploadFile = (e) => {
    let file = e.target.files[0];
    if (Boolean(file)) {
      setFile(file);
    }
  };

  const year = date ? moment(date).format('YYYY') : null;
  const fileName = file?.name ? file.name : '';

  const uploadForm101 = () => {
    const {email} = user;
    dispatch(actions.uploadForm101({userMongoId, file, form101: 1, year, email}))
      .then(() => {
        dispatch(actions.fetchUser({userId: userMongoId}));
      })
      .then(() => {
        uploadRef.current.value = null
        setFile(null);
      })
      .then(() => onHide())
      .catch((error) => {
        console.error(`Error: + ${error}`);
      });
  };

  return (
    <Modal show={isOpen} onHide={onHide}>
      <div className={'p-6'}>
        <Modal.Title className={'text-primary text-center'}>
          <FormattedMessage
            id="userDetails-files-upload-form-101"
            defaultMessage="Upload form 101"
          />
        </Modal.Title>
        <Modal.Body>
          <div className={'w-150px mx-auto mb-4'}>
            <DatePicker
              picker={'year'}
              className={'form-control d-flex mb-8'}
              placeholder={''}
              onChange={date => setDate(date.$d)}
              locale={locale}
              format={'YYYY'}
              clearIcon={false}
              suffixIcon={false}
              showToday={false}
            />
            <label className={'btn btn-sm btn-primary w-100'}>
              <FormattedMessage
                id="userDetails-files-upload-101"
                defaultMessage="Upload"
              />
              <input
                type="file"
                className="d-none"
                id="uploadedFile"
                onChange={uploadFile}
                onInput={e => console.log({target: e.target})}
                ref={uploadRef}
              />
            </label>
          </div>
          {fileName && (
            <div
              className={'h5 mx-auto p-2 border-bottom border-4 text-center'}
              style={{
                maxWidth: '450px',
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
            >
              {fileName}
            </div>
          )}
        </Modal.Body>
        <div className={'d-flex justify-content-center'}>
          <Button
            variant="secondary"
            size="sm"
            onClick={onHide}
            className={'w-100px'}
          >
            <FormattedMessage
              id="userDetails-files-generate-pdf-close-101"
              defaultMessage="Close"
            />
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => uploadForm101()}
            className={'ml-8 w-100px'}
            disabled={!date || !file}
          >
            <FormattedMessage
              id="userDetails-files-generate-pdf-generate-101"
              defaultMessage="Generate PDF"
            />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PopupUploadForm101.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

export default PopupUploadForm101;

